import { render, staticRenderFns } from "./unions.vue?vue&type=template&id=01835987&scoped=true&"
import script from "./unions.vue?vue&type=script&lang=js&"
export * from "./unions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01835987",
  null
  
)

export default component.exports